/**
 * ApiError — a non-2xx answer of the bot API, read into a typed error.
 *
 * The server answers errors as `{ error: '<code>', ...extra }` (for example
 * `{ error: 'chart_limit', limit: 20 }`). `code` is that `error` string, or
 * `http_<status>` when the body is not JSON or has no `error`.
 */
export class ApiError extends Error {
  constructor(
    public status: number,
    public code: string,
    public body: Record<string, unknown>,
  ) {
    super(`${status} ${code}`);
    this.name = 'ApiError';
  }
}

/** Throws ApiError for a non-2xx response. Returns the response otherwise. */
export async function ensureOk(res: Response): Promise<Response> {
  if (res.ok) return res;
  let body: Record<string, unknown> = {};
  try {
    const parsed: unknown = await res.json();
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) body = parsed as Record<string, unknown>;
  } catch {
    // not JSON — keep the empty body
  }
  const code = typeof body.error === 'string' && body.error ? body.error : `http_${res.status}`;
  throw new ApiError(res.status, code, body);
}
